import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-2 bg-background" data-testid="access-denied-page">
        <h1 className="text-2xl font-heading font-semibold text-foreground">Akses Ditolak</h1>
        <p className="text-sm text-muted-foreground">Anda tidak memiliki hak akses untuk membuka halaman ini.</p>
      </div>
    );
  }

  return children;
}
